export const messages = {
  en: {
    myAuditOrders: {
      page: {
        title: 'Purchase Todo Orders',
        subtitle: 'Handle purchase audit and warehousing tasks',
        empty: 'No todo orders found'
      },
      todoList: 'Todo List',
      back: 'Back',
      refresh: 'Refresh',
      orderNumber: 'Order Number',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      applicant: 'Applicant',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      edit: 'Edit',
      procurement: 'Procurement',
      audit: 'Audit'
    }
  },
  zh: {
    myAuditOrders: {
      page: {
        title: '采购待办单',
        subtitle: '处理采购审核与入库任务',
        empty: '暂无待办单'
      },
      todoList: '待办单',
      back: '返回',
      refresh: '刷新',
      orderNumber: '订单号',
      orderType: '订单类型',
      orderStatus: '订单状态',
      applicant: '申请人',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      edit: '修改',
      procurement: '采购入库',
      audit: '审批'
    }
  }
}